import { createLazyModuleLoader } from './lazyModuleLoader.js';
import { ensureModuleWithInit } from './moduleRuntimeHelpers.js';

export function createAiDomainRuntime(context = {}) {
  const {
    importWithChunkRecovery,
    state,
    elements,
    showToast,
    escapeHtml,
    canAccessFeature = () => false,
    openMembershipCenter = () => {}
  } = context;

  let aiModuleApi = null;
  let aiModuleLoadingPromise = null;

  const loadAiModule = createLazyModuleLoader({
    importWithChunkRecovery,
    importer: () => import('./aiModule.js'),
    getApi: () => aiModuleApi,
    setApi: (mod) => {
      aiModuleApi = mod;
    },
    getLoadingPromise: () => aiModuleLoadingPromise,
    setLoadingPromise: (promise) => {
      aiModuleLoadingPromise = promise;
    }
  });

  function ensureAiModuleReady() {
    return ensureModuleWithInit(loadAiModule, {
      isInitializedExport: 'isAiModuleInitialized',
      initExport: 'initAiModule',
      createInitContext: () => ({
        state,
        elements,
        showToast,
        escapeHtml,
        canAccessFeature,
        openMembershipCenter
      })
    });
  }

  return {
    ensureAiModuleReady,
    getAiModuleApi: () => aiModuleApi
  };
}
